import React, { Component } from "react";
import image from "../../../../images/Peadodontics/HOD.png";
import { NavLink } from "react-router-dom";

export class PaedodonticsSidebar extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/Paedodontics"}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PaedodonticsFaculties"}>
                Faculties and Staff
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PaedodonticsTeaching"}>
                Teaching - Learning
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PaedodonticsResearch"}>
                Research and Innovations
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/PaedodonticsActivities"}>
                Activities
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="widget">
          <div className="section-title with-desc text-left clearfix">
            <div className="title-header">
              <h2 className="title">
                Head of the <span>department</span>
              </h2>
            </div>
          </div>

          <div className="ttm_single_image-wrapper mb-35 res-991-mb-20">
            <img
              className="d-block w-100"
              src={image}
              alt="Dr Vivek Dhruva Kumar"
            />
          </div>

          <h4>Dr. Vivek Dhruva Kumar</h4>
          <p>Professor & HOD</p>

          <h6>Education and Qualification:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i>
              BDS: Vokkaligara Sangha Dental College and Hospital, Bangalore
              (1990 – 1995)
            </li>
            <li>
              <i className="fas fa-star"></i>
              MDS: Paedodontics and Preventive Dentistry, SDM Dental College,
              Dharwad (1999 – 2001)
            </li>
          </ul>

          <br />

          <h6>Work Experience:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i> Assistant Professor (2001 – 2004)
              – Dr. Syamala Reddy Dental College
            </li>
            <li>
              <i className="fas fa-star"></i> Associate Professor (2004 – 2007)
              – KGF Dental College & Ekalavya Dental College
            </li>
            <li>
              <i className="fas fa-star"></i> Associate Professor (2007 – 2010)
              – V.S Dental College
            </li>
            <li>
              <i className="fas fa-star"></i> Professor (2010 – Present)
            </li>
            <li>
              <i className="fas fa-star"></i> Professor & HOD (2025 – Till Date)
            </li>
            <li>
              <i className="fas fa-star"></i> Total 24 Years of Teaching
              Experience
            </li>
          </ul>
        </div>
        <div className="widget widget-download">
          <h3 className="widget-title">Contact</h3>
          <ul className="download">
            <li>
              <i className="fa fa-phone" />
              <a> 080-22426705</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default PaedodonticsSidebar;
